module.exports = __webpack_public_path__ + "media/memory-bank/levelbuilding-avatar-a946b4bb.png";